import { render, staticRenderFns } from "./FileToTextModel.vue?vue&type=template&id=05f3163a&"
import script from "./FileToTextModel.vue?vue&type=script&lang=js&"
export * from "./FileToTextModel.vue?vue&type=script&lang=js&"
import style0 from "./FileToTextModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports